module.exports = __webpack_public_path__ + "static/media/zelda_0.6d2d8cf5.png";